// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttons {
  float: right;
}
.text {
  font-weight: 500;
}
.space {
  margin-bottom: 0.8rem;
  float: right;
}
.btn-edit {
  margin: auto;
  margin-bottom: -13px;
}
.img {
  width: 100%;
  text-align: center;
  border: none !important;
}
::-webkit-scrollbar {
  display: none;
}
.img-btn {
  width: 105px;
  height: 105px;
  border-radius: 50%;
  text-align: center;
  font-size: smaller;
  background-color: #d6d3d3;
  margin-bottom: 20px;
  margin-top: 20px;
}
.ant-table-thead .ant-table-cell {
  background-color: #0883b3 !important;
}
.btn-pos {
  width: 75%;
  display: flex;
  justify-content: center;
}
@media only screen and (max-width: 426px) and (min-width: 320px) {
  .space {
    width: 100%;
  }
  .btn-pos {
    width: 100%;
    display: flex;
    margin-right: 30px;
    justify-content: center;
  }
}
@media print {
  .hide-on-print {
    display: none !important;
  }
}
.yellow {
  color: 2px solid yellow !important;
}
.selected-menu {
  color: #fa8c15 !important;
}
.background-color-sidebar {
  background-color: #0e74bc !important;
}
.background-color-header {
  background-color: #fff !important;
}
.ant-drawer-body {
  background-color: #0e74bc !important;
}
.menu-text {
  color: white !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/modules/doctor.less"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;AACzB;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,kCAAkC;AACpC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,uBAAuB;AACzB","sourcesContent":[".buttons {\n  float: right;\n}\n.text {\n  font-weight: 500;\n}\n.space {\n  margin-bottom: 0.8rem;\n  float: right;\n}\n.btn-edit {\n  margin: auto;\n  margin-bottom: -13px;\n}\n.img {\n  width: 100%;\n  text-align: center;\n  border: none !important;\n}\n::-webkit-scrollbar {\n  display: none;\n}\n.img-btn {\n  width: 105px;\n  height: 105px;\n  border-radius: 50%;\n  text-align: center;\n  font-size: smaller;\n  background-color: #d6d3d3;\n  margin-bottom: 20px;\n  margin-top: 20px;\n}\n.ant-table-thead .ant-table-cell {\n  background-color: #0883b3 !important;\n}\n.btn-pos {\n  width: 75%;\n  display: flex;\n  justify-content: center;\n}\n@media only screen and (max-width: 426px) and (min-width: 320px) {\n  .space {\n    width: 100%;\n  }\n  .btn-pos {\n    width: 100%;\n    display: flex;\n    margin-right: 30px;\n    justify-content: center;\n  }\n}\n@media print {\n  .hide-on-print {\n    display: none !important;\n  }\n}\n.yellow {\n  color: 2px solid yellow !important;\n}\n.selected-menu {\n  color: #fa8c15 !important;\n}\n.background-color-sidebar {\n  background-color: #0e74bc !important;\n}\n.background-color-header {\n  background-color: #fff !important;\n}\n.ant-drawer-body {\n  background-color: #0e74bc !important;\n}\n.menu-text {\n  color: white !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
